import intro from "images/IntroDuction.jpg";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NcImage from "shared/NcImage/NcImage";
export default function SectionOurIntroduction() {
  return (
    <div className="container grid grid-cols-12 gap-5 py-8 items-center">
      <div className="col-span-12 lg:col-span-6 flex items-center justify-center">
        <NcImage
          src={intro}
          alt="Devi Plastic manufacturing unit – sink coupling and die making manufacturer in Ahmedabad"
          className="w-full h-auto max-h-80 sm:max-h-96 object-contain rounded-md"
        />
      </div>
      <div className="col-span-12 lg:col-span-6">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight">
          Leading{" "}
          <span className="text-primary-500">Sink Coupling Manufacturer</span>{" "}
          in India
        </h2>

        <p className="mt-5 text-sm sm:text-base md:text-lg lg:text-xl text-justify leading-relaxed max-w-prose">
          <strong>Devi Plastic</strong> is a trusted manufacturer and supplier
          of
          <strong> premium sink couplings</strong> based in
          <strong> Ahmedabad, Gujarat (India)</strong>. We specialize in
          producing high-quality <strong>plastic sink waste couplings</strong>{" "}
          for kitchen and bathroom drainage systems, designed for durability,
          precision, and long-term performance.
        </p>

        <p className="mt-4 text-sm sm:text-base md:text-lg lg:text-xl text-justify leading-relaxed max-w-prose">
          With strong expertise in <strong>die making</strong>,{" "}
          <strong>plastic molding</strong>, and{" "}
          <strong>steel component manufacturing</strong>, we also develop{" "}
          <strong>custom dies</strong> and engineered solutions to meet diverse
          industrial requirements. Our manufacturing process focuses on quality
          control, accuracy, and reliable supply across India.
        </p>
      </div>
    </div>
  );
}
